module.exports = __webpack_public_path__ + "static/media/449GriffinStNW_2018-06-05_32.d8634c2b.jpg";